import React, { useState, useEffect } from "react";
import axios from "axios";
import PurchaseHeader from "../../../Pdf/PrintHeaderAccount";
import config from "../../../config";
import PrintFooter from "../../../Pdf/PrintFooter";
import { saleReportStyles } from "../../../Pdf/pdfStyles";
import { PrintFormateNumber, parseReportAmount } from "../../../Pdf/PrintFormateNumber";
import {
  PDFViewer,
  Page,
  Text,
  View,
  Document,
} from "@react-pdf/renderer";
import { Spin } from "antd";
import moment from "moment";

const PURCHASE_COL = {
  sr: 26,
  dated: 54,
  supplier: 112,
  product: 74,
  vehicle: 46,
  price: 52,
  qty: 52,
  amount: 151,
};
const PURCHASE_TABLE_WIDTH =
  PURCHASE_COL.sr +
  PURCHASE_COL.dated +
  PURCHASE_COL.supplier +
  PURCHASE_COL.product +
  PURCHASE_COL.vehicle +
  PURCHASE_COL.price +
  PURCHASE_COL.qty +
  PURCHASE_COL.amount;

const parseFilterId = (value) => {
  const id = parseInt(value, 10);
  return Number.isFinite(id) && id > 0 ? id : 0;
};

const resolveProductLabel = (productId, urlName, purchaseList) => {
  if (urlName) return decodeURIComponent(urlName);
  if (!productId) return "All Products";

  const fromRow = (purchaseList || []).find(
    (p) => (p.Product_ID || p.Product_BE?.ID) === productId
  );
  if (fromRow?.Product_BE?.Name) return fromRow.Product_BE.Name;

  return "Selected Product";
};

const resolveSupplierLabel = (supplierId, urlName, purchaseList) => {
  if (urlName) return decodeURIComponent(urlName);
  if (!supplierId) return "All Suppliers";

  const fromRow = (purchaseList || []).find(
    (p) => (p.Account_ID || p.Account_BE?.ID) === supplierId
  );
  if (fromRow?.Account_BE?.Name) return fromRow.Account_BE.Name;

  return "Selected Supplier";
};

function PrintPurchaseReport() {
  const [loading, setLoading] = useState(false);

  const UserID = localStorage.getItem("ID");
  const AccessKey = localStorage.getItem("AccessKey");

  const urlParams = new URLSearchParams(window.location.search);
  const EndDate = urlParams.get("EndDate");
  const StartDate = urlParams.get("StartDate");
  const OrderBy = urlParams.get("Orderby");
  const ProductID = urlParams.get("ProductID");
  const SupplierID = urlParams.get("SupplierID");
  const VehicleNo = urlParams.get("VehicleNo") || "";
  const ProductName = urlParams.get("ProductName");
  const SupplierName = urlParams.get("SupplierName");

  const [purchaseList, setPurchaseList] = useState([]);
  const [data, setData] = useState({});

  useEffect(() => {
    document.title = "Print Purchase Report";
    setLoading(true);

    const payload = {
      UserID: UserID,
      AccessKey: AccessKey,
      OrderBy: OrderBy,
      PageNo: 1,
      PageSize: 20000,
      StartDate: StartDate,
      EndDate: EndDate,
      ProductID: ProductID || 0,
      SupplierID: SupplierID || 0,
      VehicleNo: VehicleNo,
    };

    axios({
      method: "post",
      url: config.base_url + "Report/GetPurchaseReport",
      headers: { "Content-Type": "application/json" },
      data: payload,
    })
      .then(function (response) {
        if (response.data.status_code == 1) {
          setPurchaseList(response.data.listofPurchase || []);
          setData(response.data);
        }
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  }, []);

  const generateData = () => {
    if (purchaseList.length > 0) {
      return purchaseList.map((item, index) => (
        <View key={index} style={saleReportStyles.row}>
          <View style={[saleReportStyles.td, { width: PURCHASE_COL.sr }]}>
            <Text style={saleReportStyles.tdValue}>{index + 1}</Text>
          </View>
          <View style={[saleReportStyles.td, { width: PURCHASE_COL.dated }]}>
            <Text style={saleReportStyles.tdValue}>
              {moment(item.Purchase_InvoiceHead_BE?.Dated).format(
                config.date_format
              )}
            </Text>
          </View>
          <View style={[saleReportStyles.td, { width: PURCHASE_COL.supplier }]}>
            <Text style={saleReportStyles.tdValue}>
              {item.Account_BE?.Name || "-"}
            </Text>
          </View>
          <View style={[saleReportStyles.td, { width: PURCHASE_COL.product }]}>
            <Text style={saleReportStyles.tdValue}>
              {item.Product_BE?.Name || "-"}
            </Text>
          </View>
          <View style={[saleReportStyles.td, { width: PURCHASE_COL.vehicle }]}>
            <Text style={saleReportStyles.tdValue}>
              {item.Vehicle_No || "-"}
            </Text>
          </View>
          <View
            style={[
              saleReportStyles.td,
              { width: PURCHASE_COL.price, textAlign: "right" },
            ]}
          >
            <Text style={saleReportStyles.tdValue}>
              {PrintFormateNumber(item.Price, 2)}
            </Text>
          </View>
          <View
            style={[
              saleReportStyles.td,
              { width: PURCHASE_COL.qty, textAlign: "right" },
            ]}
          >
            <Text style={saleReportStyles.tdValue}>
              {PrintFormateNumber(item.Quantity, 2)}
            </Text>
          </View>
          <View
            style={[
              saleReportStyles.td,
              { width: PURCHASE_COL.amount, textAlign: "right" },
            ]}
          >
            <Text style={saleReportStyles.tdValue}>
              {PrintFormateNumber(item.Amount ?? item.TotalAmount, 0)}
            </Text>
          </View>
        </View>
      ));
    }
  };

  const MyDocument = () => {
    const productId = parseFilterId(ProductID);
    const supplierId = parseFilterId(SupplierID);
    const productLabel = resolveProductLabel(
      productId,
      ProductName,
      purchaseList
    );
    const supplierLabel = resolveSupplierLabel(
      supplierId,
      SupplierName,
      purchaseList
    );
    const periodLabel = `${
      StartDate ? moment(StartDate).format(config.date_format) : "-"
    } to ${EndDate ? moment(EndDate).format(config.date_format) : "-"}`;
    const vehicleLabel = VehicleNo ? VehicleNo : "All";

    return (
      <Document>
        <Page size="A4" style={saleReportStyles.page}>
          <PurchaseHeader compact />
          <View style={saleReportStyles.section}>
            <View style={saleReportStyles.titleBlock}>
              <Text style={saleReportStyles.pagetitle}>Purchase Report</Text>
              <Text style={saleReportStyles.reportSubtitle}>
                Period: {periodLabel}
              </Text>
              <Text style={saleReportStyles.reportSubtitle}>
                Supplier: {supplierLabel}    Product: {productLabel}
              </Text>
              {VehicleNo ? (
                <Text style={saleReportStyles.reportSubtitle}>
                  Vehicle No: {vehicleLabel}
                </Text>
              ) : null}
            </View>

            <View style={saleReportStyles.table}>
              <View style={saleReportStyles.tableHead}>
                <View style={[saleReportStyles.th, { width: PURCHASE_COL.sr }]}>
                  <Text style={saleReportStyles.thValue}>Sr. No.</Text>
                </View>
                <View
                  style={[saleReportStyles.th, { width: PURCHASE_COL.dated }]}
                >
                  <Text style={saleReportStyles.thValue}>Dated</Text>
                </View>
                <View
                  style={[saleReportStyles.th, { width: PURCHASE_COL.supplier }]}
                >
                  <Text style={saleReportStyles.thValue}>Supplier</Text>
                </View>
                <View
                  style={[saleReportStyles.th, { width: PURCHASE_COL.product }]}
                >
                  <Text style={saleReportStyles.thValue}>Product</Text>
                </View>
                <View
                  style={[saleReportStyles.th, { width: PURCHASE_COL.vehicle }]}
                >
                  <Text style={saleReportStyles.thValue}>Vehicle</Text>
                </View>
                <View
                  style={[
                    saleReportStyles.th,
                    { width: PURCHASE_COL.price, textAlign: "right" },
                  ]}
                >
                  <Text style={saleReportStyles.thValue}>Price</Text>
                </View>
                <View
                  style={[
                    saleReportStyles.th,
                    { width: PURCHASE_COL.qty, textAlign: "right" },
                  ]}
                >
                  <Text style={saleReportStyles.thValue}>Quantity</Text>
                </View>
                <View
                  style={[
                    saleReportStyles.th,
                    { width: PURCHASE_COL.amount, textAlign: "right" },
                  ]}
                >
                  <Text style={saleReportStyles.thValue}>Amount</Text>
                </View>
              </View>

              {generateData()}

              <View style={saleReportStyles.totalsRow}>
                <View
                  style={[
                    saleReportStyles.th,
                    {
                      width: PURCHASE_TABLE_WIDTH - PURCHASE_COL.amount,
                      textAlign: "right",
                    },
                  ]}
                >
                  <Text style={saleReportStyles.thValue}>Total Purchase</Text>
                </View>
                <View
                  style={[
                    saleReportStyles.th,
                    { width: PURCHASE_COL.amount, textAlign: "right" },
                  ]}
                >
                  <Text style={saleReportStyles.thValue}>
                    {PrintFormateNumber(
                      parseReportAmount(data.totalPurchase),
                      0
                    )}
                  </Text>
                </View>
              </View>
              <View style={saleReportStyles.totalsRow}>
                <View
                  style={[
                    saleReportStyles.th,
                    {
                      width: PURCHASE_TABLE_WIDTH - PURCHASE_COL.amount,
                      textAlign: "right",
                    },
                  ]}
                >
                  <Text style={saleReportStyles.thValue}>
                    Total Petrol (Ltr)
                  </Text>
                </View>
                <View
                  style={[
                    saleReportStyles.th,
                    { width: PURCHASE_COL.amount, textAlign: "right" },
                  ]}
                >
                  <Text style={saleReportStyles.thValue}>
                    {PrintFormateNumber(parseReportAmount(data.totalPetrol))}
                  </Text>
                </View>
              </View>
              <View style={saleReportStyles.totalsRow}>
                <View
                  style={[
                    saleReportStyles.th,
                    {
                      width: PURCHASE_TABLE_WIDTH - PURCHASE_COL.amount,
                      textAlign: "right",
                    },
                  ]}
                >
                  <Text style={saleReportStyles.thValue}>
                    Total Diesel (Ltr)
                  </Text>
                </View>
                <View
                  style={[
                    saleReportStyles.th,
                    { width: PURCHASE_COL.amount, textAlign: "right" },
                  ]}
                >
                  <Text style={saleReportStyles.thValue}>
                    {PrintFormateNumber(parseReportAmount(data.totalDiesel))}
                  </Text>
                </View>
              </View>
            </View>

            <View
              style={{ marginBottom: 20, marginTop: 0, top: 6, bottom: 6 }}
              fixed
            >
              <Text
                style={{ fontSize: "7pt", color: "#000" }}
                render={({ pageNumber, totalPages }) =>
                  `Page ${pageNumber} / ${totalPages}`
                }
              />
            </View>
          </View>
          <PrintFooter fixed />
        </Page>
      </Document>
    );
  };

  return (
    <div style={{ width: "100%", height: "100vh", overflow: "hidden" }}>
      {loading ? (
        <div
          style={{
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Spin />
        </div>
      ) : (
        <PDFViewer width="100%" height="100%" fileName="purchase-report.pdf">
          <MyDocument />
        </PDFViewer>
      )}
    </div>
  );
}

export default PrintPurchaseReport;
